module.exports = __webpack_public_path__ + "img/instagram.60bb4dd5.png";